module.exports = __webpack_public_path__ + "img/birday.d6380b67.png";